const cfg = {
    server:'park.bankoi.biz',
    apiVer: 'v1',
    apiURL: "https://park.bankoi.biz/api",
    filesHost: "https://park.bankoi.biz",
    langs: {es:'Español', pt:'Português', gl:'Galego', ca:'Català',  en:'English', de:'Deutsch'},
    locales: {es:'es-ES', pt:'pt-PT', gl:'gl-ES', ca:'ca-ES',  en:'en-GB', de:'de-DE'},

    publicLangs: [{id:'es', name:'Español'}],
    publicDefaultLang:'es',

    defaultLang :'es',
    colorTheme:'light',
    fontTheme:'14px',
    listRowCount:10
}

export default cfg;
